<template>
    <div id="newMiniFilterPreview">
        <div class="title">
            {{ filter.name }}
            {{ getValue() }}
            {{ OPERATORS_TYPES[filter.rule] }}
            <span class="material-icons" style="font-size: 16px; cursor: pointer" @click="deleteFilter"> close </span>
        </div>
        <template v-for="input of getInputs()">
            <div v-if="input.type == 'select'" class="dropdown-picker">
                <a-select v-if="input.multiple" v-model:value="input.value" mode="multiple" style="width: 100%">
                    <a-select-option
                        v-for="option of input.data"
                        :key="option.key"
                        :value="option.key"
                        style="display: flex; align-items: center"
                    >
                        <div class="option-wrapper">
                            <SupsisIcon v-if="option.key === 'supsis'" color="#25D366" class="option-icon" />
                            <WhatsappIcon v-if="option.key === 'whatsapp'" color="#25D366" class="option-icon" />
                            <TelegramIcon v-if="option.key === 'telegram'" class="option-icon" />
                            <MessengerIcon v-if="option.key === 'messenger'" class="option-icon" />
                            <webIcon v-if="option.key === 'web'" class="option-icon" color="black;" />
                            <mailIcon v-if="option.key === 'email'" class="option-icon" />
                            <MetaIcon v-if="option.key === 'meta-leads'" class="option-icon" />
                            <InstagramIcon
                                v-if="option.key === 'instagram'"
                                class="option-icon"
                                special-background-mode
                            />
                            <span v-if="option.key === 'calendar'" class="md-icon">calendar_month</span>
                            {{ option.value }}
                        </div>
                    </a-select-option>
                </a-select>
                <a-select v-else v-model:value="input.value" style="width: 100%">
                    <a-select-option v-for="option of input.data" :key="option.key" :value="option.key">
                        {{ option.value }}
                    </a-select-option>
                </a-select>
            </div>
            <div v-else-if="input.type == 'text'" class="input-picker" style="margin-top: 3px">
                <a-input v-model:value="input.value" style="width: 100%" />
            </div>
            <div v-else-if="input.type == 'date'" class="date-select-picker" style="margin-top: 3px">
                <a-select v-model:value="input.period" style="width: 100%; margin-bottom: 5px">
                    <a-select-option :value="'today'"> Bugün</a-select-option>
                    <a-select-option :value="'yesterday'"> Dün</a-select-option>
                    <a-select-option :value="'last7'"> Bu Hafta</a-select-option>
                    <a-select-option :value="'last30'"> Son 30 Gün</a-select-option>
                    <a-select-option :value="'this-month'"> Bu Ay</a-select-option>
                    <a-select-option :value="'last-month'"> Geçen Ay</a-select-option>
                    <a-select-option :value="'custom'"> Özel</a-select-option>
                </a-select>
                <a-range-picker v-if="input.period == 'custom'" v-model:value="input.value" show-time />
            </div>
        </template>
    </div>
</template>

<script>
import SupsisIcon from "../../Chatbot/pages/integrations/svg/SupsisIcon.vue";
import WhatsappIcon from "../../Chatbot/pages/integrations/svg/WhatsappIcon.vue";
import TelegramIcon from "../../Chatbot/pages/integrations/svg/TelegramIcon.vue";
import MessengerIcon from "../../Chatbot/pages/integrations/svg/MessengerIcon.vue";
import InstagramIcon from "../../Chatbot/pages/integrations/svg/InstagramIcon.vue";
import webIcon from "./svg/WebIcon.vue";
import mailIcon from "../../Mail/icons/MailIcon.vue";
import MetaIcon from "../../Chatbot/pages/integrations/svg/MetaIcon.vue";

const OPERATORS_TYPES = {
    is: "Eşit",
    is_not: "Eşit Değil",
    contains: "İçerir",
    not_contains: "İçermez",
    starts_with: "ile Başlar",
    ends_with: "ile Biter",
};

export default {
    name: "NewMiniFilterPreview",
    props: {
        filter: {
            type: Object,
            defualt: () => {},
        },
    },
    components: {
        MetaIcon,
        WhatsappIcon,
        TelegramIcon,
        MessengerIcon,
        webIcon,
        mailIcon,
        InstagramIcon,
        SupsisIcon,
    },
    data: () => ({
        OPERATORS_TYPES,
    }),
    methods: {
        deleteFilter() {
            this.$emit("deleteFilter");
        },
        getValue() {
            return this.filter.inputs[1]
                ? this.filter.inputs[0].data.find((d) => d.key == this.filter.inputs[0].value)?.value || ""
                : "";
        },
        getInputs() {
            return this.filter.inputs[1]
                ? this.filter.inputs.slice(1).map((input) => {
                      if (input.type == "select") {
                          input.value = String(input.value);
                      }
                      return input;
                  })
                : this.filter.inputs;
        },
    },
};
</script>
<style lang="scss">
#newMiniFilterPreview {
    .ant-calendar-picker {
        width: 100% !important;
    }

    .title {
        font-weight: 500;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 10px;
        margin-bottom: 3px;
    }

    .dropdown-picker,
    .date-select-picker,
    .input-picker {
        display: flex;
        flex-direction: column;
    }
}

.option-wrapper {
    display: flex;
    align-items: center;
    gap: 7px;

    .option-icon {
        height: 20px;
        width: 20px;
        padding: 0;
    }

    .md-icon {
        margin: 0 !important;
        width: 19px;
        min-width: 19px;
        height: 19px;
    }
}
</style>
